import React from 'react';
import styles from './SubAssemblyToolbar.module.css';
import LineDropdownSelector from '../LineDropdownSelector/LineDropdownSelector';

const SubAssemblyToolbar = ({ plantName }) => {
  return (
    <>
      <div className={styles.RgtTools}>
        <div className={styles.subAssemblyToolbar}>
          <div className={styles.plantName}>
            Selected Plant - {plantName}
          </div>
          <div style={{ marginLeft: '16px', minWidth: '200px' }}>
            <LineDropdownSelector />
          </div>
        </div>
      </div>
    </>
  );
};

export default SubAssemblyToolbar;
